/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	},
};

(function () {
	BoostPFS.inject(this);

	// Clear button for the Form Search
	HTMLDocument.prototype.ready = function () {
		return new Promise(function (resolve, reject) {
			if (document.readyState === 'complete') {
				resolve(document);
			} else {
				document.addEventListener('DOMContentLoaded', function () {
					resolve(document);
				});
			}
		});
	};

	document.ready().then(function () {
		var inputSearchFormSelector = jQ('.boost-pfs-search-input');
		var clearSearchFormSelector = jQ('.boost-pfs-search-form-btn-clear');

		if (!!inputSearchFormSelector.val()) {
			clearSearchFormSelector.show();
		}

		inputSearchFormSelector.on('change keydown keyup', function () {
			if (!!jQ(this).val()) {
				clearSearchFormSelector.show();
			} else {
				clearSearchFormSelector.hide();
			}
		});

		clearSearchFormSelector.on('click', function () {
			inputSearchFormSelector.val('');
			jQ(this).hide();
			inputSearchFormSelector.click();
		});
	}); // End Clear button for the Form Search

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function () {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

	// Bind Event for input search Mobile
	var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
	InstantSearchMobile.prototype.bindEvents = function () {
		bindEventsMobile.call(this);

		var self = this;
		var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
		var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
		var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
		jQ(searchButtonMobile)
			.off('click')
			.click(function (e) {
				e.preventDefault();
				//e.stopPropagation();
				jQ(searchInputMobile).focus();
				self.openSuggestionMobile();
				jQ(searchCloseButtonMobile).trigger('click');
			});
	};

	// Bind Event for input search style 3
	var bindEvents = InstantSearchStyle3.prototype.bindEvents;
	InstantSearchStyle3.prototype.bindEvents = function () {
		bindEvents.call(this);

		var self = this;
		var searchButtonDesktop = '.site-header__links .search-button';
		var searchInputDesktop = '#SearchContainer #search-input';
		var searchCloseButtonDesktop = '.drawer__close > button';
		jQ(searchButtonDesktop)
			.off('click')
			.click(function (e) {
				e.preventDefault();
				//e.stopPropagation();
				jQ(searchInputDesktop).focus();
				self.openSuggestionStyle3();
				jQ(searchCloseButtonDesktop).trigger('click');
			});
	};

	// Fix search for the Flow theme
	jQ('.site-header__links .search-button').on('click', function () {
		setTimeout(function () {
			boostPFS.initSearchBox();
			if (Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
		}, 500);
	});

	InstantSearchResultItemPopular.prototype.checkForRedirectData = function () {
		// Check for redirect search term
		var instantSearchResult = this.parent.parent;
		// Old way: using the "redirect" field, can only store 1 URL
		if (instantSearchResult.hasRedirectData && instantSearchResult.redirectData && instantSearchResult.searchQuery == this.data) {
			return instantSearchResult.redirectData;
		}
		// New way: using the "suggestions_redirect" field
		var suggestionsRedirect = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.SUGGESTIONS_REDIRECT, instantSearchResult.data);
		if (suggestionsRedirect && suggestionsRedirect[this.data]) {
			console.log(suggestionsRedirect[this.data]);
			return suggestionsRedirect[this.data];
		}
		// Else, no redirects
		return '';
	};

    InstantSearchResultRedirect.checkForSearchRedirect = ($element) => {
    	if ($element.data('search-submit')) {
    		$element.removeAttr('data-search-submit');
    		var redirectUrl = InstantSearchResultRedirect.getSearchRedirectUrl();
    		if (redirectUrl) {
                if (Shopify.locale == "en"){
                  redirectUrl = redirectUrl.replace('https://columbia.vn/', 'https://columbia.vn/en/');
                }
    			Utils.setWindowLocation(redirectUrl);
    		} else {
    			$element.closest('form').trigger('submit', [true]);
    		}
    	}
    }

   SearchInput.prototype._onSubmit = function(event, redirect) {

		if (typeof redirect == 'undefined') {
			redirect = this.isChangePage;
		}
		this.isChangePage = false;

		if (!redirect) {
			// Stop all default submit events
			event.stopImmediatePropagation();
			event.stopPropagation();
			event.preventDefault();
			// Fix case can not get current value from input
			Globals.currentTerm = Utils.stripHtml(this.$element.val());
			if (!Globals.currentTerm && event && event.target) {
				Globals.searchTerm = Utils.stripHtml(event.target.value);
			}
			var redirectUrl = InstantSearchResultRedirect.getSearchRedirectUrl();

			// if API returned results or the suggestionCache has the search term, submit search
			// else: add the data-search-submit attribute to the search input box, wait for the api returns the result,
			// then remove this attribute in the checkForSearchRedirect function
			var query = Utils.unescape(Globals.currentTerm);
			query = query.trim().replace(/\s+/g, ' ');
			var isApiReturnedResult = Globals.suggestionCache.hasOwnProperty(query);
			// Set recent searches
			InstantSearchOnclick.setOnClickRecentSearches(query);
			// If the API returned results, either redirect or perform submit
            console.log('isApiReturnedResult', isApiReturnedResult)
			if (isApiReturnedResult) {
				if (redirectUrl && !Utils.isBadUrl(redirectUrl)) {
                    if (Shopify.locale == "en"){
                      redirectUrl = redirectUrl.replace('https://columbia.vn/', 'https://columbia.vn/en/');
                    }
					Utils.setWindowLocation(redirectUrl);
				} else {
					this.isChangePage = true;
					this.$searchForm[0].submit();
				}
			} else if (Globals.currentTerm) {
				// If the API hasn't returned results, set data-search-submit on the search input and wait
				this.$element.data('search-submit', true);
			} else {
				this.isChangePage = true;
				this.$searchForm[0].submit();
			}
		}
	}

	document.addEventListener('click', function (event) {
		if (event.target.closest('.boost-pfs-search-suggestion-group[data-group="default_suggestions"]')) {
			event.preventDefault();
			let redirectAPI = `https://services.mybcapps.com/bc-sf-filter/search/redirects?shop=${Shopify.shop}`;
			let currentSearchTerm = event.target.closest('.boost-pfs-search-suggestion-item').getAttribute('data-title');
            // let currentSearchTerm = event.target.innerText;
			fetch(redirectAPI)
				.then((response) => response.text())
				.then((responseText) => {
					let redirectData = JSON.parse(responseText);
					if (redirectData.data.length <= 0) {
						window.location.href = event.target.href;
					} else {
                        let hasRedirect = false;
                        let redirectTo = null;
						for (let i = 0; i < redirectData.data.length; i++) {
							if (redirectData.data[i].terms.length > 0) {
								for (let j = 0; j < redirectData.data[i].terms.length; j++) {
									if (redirectData.data[i].terms[j] == currentSearchTerm) {
										hasRedirect = true;
										redirectTo = redirectData.data[i].redirect_to;
                                        break;
									}
								}
							}
                            if(hasRedirect){
                              break;
                            }
						}
                        if (hasRedirect) {
                            if(Shopify.locale !== 'vi' && !redirectTo.includes('/'+Shopify.locale+'/')){
                              redirectTo = redirectTo.replace('https://columbia.vn/','https://columbia.vn/'+ Shopify.locale + '/');
                            }
                            window.location.href = redirectTo;
                        } else {
                            window.location.href = event.target.href;
                        }
					}
				})
				.catch((e) => {
					// console.error(e);
				});
		}
	});
})();
